<template>
  <transition name="fade" @after-enter="showContent = true" >
    <div
      id="padre-fondo"
      class="vue-modal"
      v-if="open"
      @keypress.esc="showContent = false"
      tabindex="0"
      @click="eventoCerrar($event.target)"
    >
      <transition name="modal" @after-leave="close">
        <div class="vue-modal-dialog" :class="modalSize" v-if="showContent">
          <div class="vue-modal-content" :class="colorBorde">
            <div class="modal-header">
              <h4 class="modal-title">
                <slot name="title"></slot>
              </h4>
              <button type="button" class="close" @click="showContent = false">
                <span  aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <slot name="body"></slot>
            </div>
            <div class="modal-footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
const escapeHandler = (e) => {
  if (e.key === "Escape" && this.showContent) {
    this.showContent = false;
  }
};

export default {
  data() {
    return {
      showContent: false,
      open: false,
    };
  },
  props: {
    size: {
      validator: function (value) {
        // The value must match one of these strings
        return ["xs", "sm", "md", "lg"].indexOf(value) !== -1;
      },
      default: "lg",
    },
    colorBorde: null,
  },
  created() {
    document.addEventListener("keydown", escapeHandler);
  },
  mounted() {
    setTimeout(() => (this.open = true), 100);
    // document.body.classList.add("no-scrollable");

    // document.querySelector(".sidebar").style.zIndex = 0;
  },
  unmounted() {
    // document.removeEventListener("keydown", escapeHandler);
    document.body.classList.remove("no-scrollable");
    // document.querySelector(".sidebar").style.zIndex = 3;
  },
  methods: {
    close() {
      this.$emit("close");
      // document.body.classList.remove("no-scrollable");
    },
    eventoCerrar(target){
      if (target.id === "padre-fondo")  this.showContent= false
    },
  },
  computed: {
    modalSize() {
      return "modal-" + this.size;
    },
  },
};
</script>

<style lang="scss">
body {
	background: white !important;
}

.modal-title {
	color: #8b8b8b !important;
}

.error{
   box-shadow: 0 0 55px 0 red !important;
}
.warning{
   box-shadow: 0 0 55px 0 yellow !important;
}
.success{
   box-shadow: 0 0 55px 0 green !important;
}

.main-modal section {
	border-bottom: solid #8b8b8b 1px !important;
}

.vue-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 150 !important;
  outline: 0;
  background: rgba(0, 0, 0, 0.5);

  .vue-modal-dialog {
    position: relative;
    width: auto;
    margin: 3rem auto;
    pointer-events: none;

    &.modal {
      &-xs {
        max-width: 300px;
      }
      &-sm {
        max-width: 80%;
        // max-width: 450px;
      } 
      &-md {
        max-width: 800px;
      }
      &-lg {
        max-width: 100%;
      }
    }

    .vue-modal-content {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      pointer-events: auto;
      background-color: #8b8b8b;
      background-clip: padding-box;
      border: 2px solid 0 0 10px 0;
      border-radius: 0.3rem;
      box-shadow: 0 0 10px 0 #a8a4a4fc !important;
	  background: white !important;
      outline: 0;

      .modal-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem;
        border-bottom: 1px solid #8b8b8b !important;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
      }

      .modal-header .close {
        padding: 1rem;
        margin: -1rem -1rem -1rem auto;
      }

      .modal-title {
        margin-bottom: 0;
        line-height: 1.5;
		border-bottom: 1px solid #8b8b8b !important;
      }

      .modal-body {
        max-height: 78vh;
        position: relative;
        overflow: auto;
        // flex: 1 1 auto;
        padding: 1rem;
      &::-webkit-scrollbar {
    width: 5px;

    /* Track */
    &-track {
      background: #ccc;
       border-radius: 5px;
    }

    /* Handle */
    &-thumb {
      background: #888;
       border-radius: 5px;
    }

    /* Handle on hover */
    &-thumb:hover {
      background: #555;
    }
  }
  }

      .modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 1rem;
        border-top: 1px solid #8b8b8b !important;
      }

      .modal-footer > :not(:first-child) {
        margin-left: 0.25rem;
      }

      .modal-footer > :not(:last-child) {
        margin-right: 0.25rem;
      }
    }
  }
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-centered {
    min-height: calc(100% - (1.75rem * 2));
  }
  .modal-content {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
  }
}

.no-scrollable {
  // margin: 0;
  // height: 100%;
  overflow: hidden ;
}

.btn-theme-colored {
	background: #396fa5 !important;
}
</style>
